<div class="modal-header border-bottom-0">
  <h5 class="modal-title">{{'common.downloads.label' | translate}}</h5>
  <button (click)="activeModal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body pb-5">
  @for (asset of assets; track asset; let i = $index) {
  <div [ngClass]="{'border-bottom': i === assets.length - 1}" class="border-top border-left border-right px-2 py-3">
    <a class="font-weight-normal text-reset" href="{{asset.value}}" target="_blank"
      >{{'common.downloads.' + asset.label | translate}}
      <fa-icon [icon]="['far', 'file-pdf']" class="text-danger" size="lg"></fa-icon>
    </a>
  </div>
  }
</div>
